import type { GeneralAccessLevel } from '../controlled/commonTypes.tsx';
import type { ConfluenceContentRestrictionStateInput } from './mutations/__generated__/useSetContentGeneralAccessModeMutation.graphql.ts';

// Mapping from UI-level general access level to GraphQL input mode
// Exhaustiveness is enforced by `satisfies` against Record<GeneralAccessLevel, ConfluenceContentRestrictionStateInput>
export const levelToMode = {
	restricted: 'VIEW_RESTRICTED',
	'open-can-view': 'EDIT_RESTRICTED',
	'open-can-edit': 'OPEN',
} as const satisfies Record<GeneralAccessLevel, ConfluenceContentRestrictionStateInput>;

export const generalAccessLevelToMode = (
	level: GeneralAccessLevel,
): ConfluenceContentRestrictionStateInput => levelToMode[level];
